import BasicResource from '@/api/resource';

class TspResource extends BasicResource {

    constructor () {
        super('tsp');
    }

    dict (params) {
        return this.client.request ({
            method: 'get',
            path: '/upyield/v1/dict/tsp',
            params: params,
        });
    }
}

export default new TspResource;
